"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'America/New_York',
};
var getFormattedDateTime = function (params) {
    var date = params.date, _a = params.locale, locale = _a === void 0 ? 'en-US' : _a, timeZone = params.timeZone, _b = params.options, options = _b === void 0 ? defaultOptions : _b;
    if (date) {
        try {
            var currentoptions = __assign(__assign({}, options), { timeZone: timeZone });
            return new Intl.DateTimeFormat(locale, currentoptions).format(new Date(date));
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return '';
        }
    }
    return '';
};
exports.default = getFormattedDateTime;
//# sourceMappingURL=getFormattedDateTime.js.map